import React from 'react';
import { Alert, Box, Chip, Stack, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ReportSection from './ReportSection';
import EmptyState from './EmptyState';
import { ALERT_CONFIG } from '../utils/orderServiceReportConfig';
import { formatMoney, formatOrderCode } from '../utils/formatters';

const OrderServiceRiskAlerts = ({ alerts = [] }) => {
    return (
        <ReportSection
            title="Alertas gerenciales"
            subtitle="Situaciones que requieren seguimiento"
            action={
                <Chip
                    icon={<WarningAmberIcon />}
                    label={`${alerts.length} alertas`}
                    color={alerts.length > 0 ? 'warning' : 'success'}
                    variant="outlined"
                />
            }
        >
            {alerts.length === 0 ? (
                <EmptyState text="No hay alertas críticas con los filtros seleccionados." />
            ) : (
                <Stack spacing={1.2}>
                    {alerts.slice(0, 10).map((item) => {
                        const config = ALERT_CONFIG[item.alert_type] || {
                            label: item.alert_type,
                            severity: 'info',
                        };

                        return (
                            <Alert
                                key={`${item.ordsercabid}-${item.alert_type}`}
                                severity={config.severity}
                                sx={{ borderRadius: 2 }}
                            >
                                <Stack
                                    direction={{ xs: 'column', md: 'row' }}
                                    justifyContent="space-between"
                                    spacing={1}
                                >
                                    <Box>
                                        <Typography variant="body2" fontWeight={800}>
                                            {formatOrderCode(item.ordsercabid)} · {config.label}
                                        </Typography>

                                        <Typography variant="caption">
                                            {item.ordsercabnom} · {item.pronom || item.serpronom || ''}
                                        </Typography>
                                    </Box>

                                    <Typography variant="body2" fontWeight={900}>
                                        {formatMoney(item.ordsercabpre)}
                                    </Typography>
                                </Stack>
                            </Alert>
                        );
                    })}
                </Stack>
            )}
        </ReportSection>
    );
};

export default OrderServiceRiskAlerts;